const themeVariables = require("!!json-loader!../../../webpack.less.vars.loader!Content/theme.variables.less");
export default themeVariables;
